import React, { useEffect, useState } from 'react'

import {
    Typography, Paper, Divider, TextField, InputAdornment, TableContainer, Table, TableHead,
    TableRow, TableBody, Pagination, Stack, Grid, useMediaQuery, CircularProgress
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';
import { styled } from '@mui/material/styles';

import { Box } from '@mui/system';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { ReactComponent as Empty } from "../assets/svg/empty.svg";
import { ReactComponent as Searching } from "../assets/svg/searching_illustration.svg";

import { Search } from '@mui/icons-material';
import Dashboard from '../components/Dashboard';

import Menu from '../components/Menu';
import BottomMenu from '../components/BottomMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getPenaltyTransactions, getTransactBooks } from '../redux/actions/transactionAction';

import moment from 'moment';


export default function TransactionPenalty() {
    const matches = useMediaQuery('(max-width:1150px)');
    const match = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const [loading, setLoading] = useState(true);
    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            },

        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        linkTexts: {
            textTransform: "none",
            color: (theme) => theme.palette.text.primary,
            fontWeight: "bold",
            fontSize: 18,
            "&: hover": {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: "transparent"
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12,
        },
        scrollableDiv: {
            maxHeight: "100vh",
            '@media only screen and (min-width: 1700px)': {
                height: 700
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            overflow: 'auto',
            //for other browsers 
            scrollbarWidth: "none"
        },
        sideDiv: {
            position: "sticky",
            height: 500

        },
    }
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#B6ADAD",
            padding: 5,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));


    const checkStatus = (status) => {
        var statusText = {
            status: "Returned",
            color: (theme) => theme.palette.success.light
        }

        return statusText;
    }

    const transaction = useSelector((state => state.transaction))

    const rows = transaction.penaltyTransactions;


    const dispatch = useDispatch();
    useEffect(() => {
        if (!transaction.penaltyEmpty && transaction.penaltyTransactions.length <= 0) dispatch(getPenaltyTransactions());
        if (!transaction.bookEmpty && transaction.transactBook.length <= 0) {
            dispatch(getTransactBooks(transaction.penaltyBookID));
        }
        else setLoading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const checkBookName = (bookID) => {
        var bookDetail = {
            bookTitle: "",
            bookAuthor: ""
        }
        for (var x = 0; x < transaction.transactBook.length; x++) {
            if (transaction.transactBook[x].bookID === bookID) {
                bookDetail = {
                    bookTitle: transaction.transactBook[x].bookTitle,
                    bookAuthor: transaction.transactBook[x].bookAuthor
                }
            }
        }
        return bookDetail
    }

    const checkDates = (objectTransact) => {
        var dateReturned = moment(objectTransact.dateReturned)
        var dateBorrowed = moment(objectTransact.dateBorrowed).add(objectTransact.duration, 'days')
        var overdueDays = dateReturned.diff(dateBorrowed, 'days')
        return overdueDays
    }

    const checkPenalty = (objectTransact) => {
        var overdueDays = checkDates(objectTransact);
        var penalty = ""
        if (overdueDays === 1) penalty = "1 Week Restriction"
        else if (overdueDays >= 2 && overdueDays <= 5) penalty = "1 Week Restriction"
        else if (overdueDays >= 6 && overdueDays <= 14) penalty = "1 Month Restriction"
        else if (overdueDays >= 15 && overdueDays <= 21) penalty = "3 Months Restriction"
        else if (overdueDays >= 22 && overdueDays <= 30) penalty = "6 Month Restriction"
        else if (overdueDays >= 31 && overdueDays <= 90) penalty = "1 Year Restriction"
        else if (overdueDays >= 121) penalty = "Lifetime Restriction"
        return penalty
    }


    const firstIndex = 0;
    const pageSize = 4;
    const [page, setPage] = useState(1);
    const [data, setData] = useState(rows.slice(firstIndex, pageSize));
    const [tempData, setTempData] = useState([])

    const handlePageChange = (event, value) => {
        if (payload.search === "") {
            setPage(value);
            setData(rows.slice(firstIndex + pageSize * (value - 1), pageSize * value));
        } else {
            setPage(value);
            setData(tempData.slice(firstIndex + pageSize * (value - 1), pageSize * value));
        }
    };

    const [payload, setPayload] = useState({
        search: ""
    })

    const handleInputChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
        if (e.target.value !== "") {
            var borrowedArray = searchBook(e.target.value)
            var tempArray = rows.filter(
                (item) =>
                    item.requestID.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1 ||
                    moment(item.dateReturned).format("MMMM Do YYYY, h:mm a").toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1
            )
            for (var x = 0; x < rows.length; x++) {
                for (var y = 0; y < borrowedArray.length; y++) {
                    if (borrowedArray[y] === rows[x].bookBorrowed) {
                        var currentStat = false;
                        for (var z = 0; z < tempArray.length; z++) {
                            if (rows[x].requestID === tempArray[z].requestID) currentStat = true;
                        }
                        if (!currentStat) tempArray.push(rows[x]);
                    }
                }
            }
            setData(tempArray.slice(firstIndex, pageSize))
            setTempData(tempArray)
        } else {
            setData(rows.slice(firstIndex, pageSize))
        }
    }

    const searchBook = (textSearch) => {
        var borrowedID = [];
        for (var x = 0; x < transaction.transactBook.length; x++) {
            if (transaction.transactBook[x].bookTitle.toLowerCase().includes(textSearch.toLowerCase()) ||
                transaction.transactBook[x].bookAuthor.toLowerCase().includes(textSearch.toLowerCase())) {
                borrowedID.push(transaction.transactBook[x].bookID)
            }
        }
        return borrowedID;
    }

    return (
        <Box>
            <SEO title="My Books - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Grid container columns={12} spacing={1}>
                        {!matches && <Grid item xs={12} md={3} sx={{ padding: 3 }}>
                            <Menu />
                        </Grid>}
                        <Grid item xs={12} md={matches ? 12 : 9}>
                            <Box sx={style.scrollableDiv}>
                                <TextField
                                    fullWidth
                                    size='small'
                                    onChange={handleInputChange("search")}
                                    sx={{ marginBottom: 2 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }} />
                                <Stack direction="column" sx={{ marginBottom: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "#280707" }}>My Books</Typography>
                                    <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: "#280707" }}>Check your book statuses here</Typography>
                                </Stack>
                                <Dashboard />
                                <Divider sx={{ marginBottom: 2 }} />
                                {!loading && data.length > 0 ?
                                    <Box>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="center">Transaction ID</StyledTableCell>
                                                        <StyledTableCell align="center">Book Title</StyledTableCell>
                                                        <StyledTableCell align="center">Book Author</StyledTableCell>
                                                        <StyledTableCell align="center">Date Returned</StyledTableCell>
                                                        <StyledTableCell align="center">Overdue Days</StyledTableCell>
                                                        <StyledTableCell align="center">Damages</StyledTableCell>
                                                        <StyledTableCell align="center">Penalty</StyledTableCell>
                                                        <StyledTableCell align="center">Status</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data.map((row) => (
                                                        <StyledTableRow key={row.requestID}>
                                                            <StyledTableCell align="center">{row.requestID.toUpperCase()}</StyledTableCell>
                                                            <StyledTableCell align="center">{checkBookName(row.bookBorrowed).bookTitle}</StyledTableCell>
                                                            <StyledTableCell align="center">{checkBookName(row.bookBorrowed).bookAuthor}</StyledTableCell>
                                                            <StyledTableCell align="center">{moment(row.dateReturned).format('MMMM Do YYYY, h:mm a')}</StyledTableCell>
                                                            <StyledTableCell align="center">{checkDates(row) === 0 ? "---" : checkDates(row) + " Day/s"} </StyledTableCell>
                                                            <StyledTableCell align="center">{row.withDamage ? row.damages : "---"}</StyledTableCell>
                                                            <StyledTableCell align="center">{checkPenalty(row) === "" ? "---" : checkPenalty(row)}</StyledTableCell>
                                                            <StyledTableCell align="center"
                                                                sx={{
                                                                    color: checkStatus(row.status).color,
                                                                    textTransform: "uppercase",
                                                                    fontWeight: "bold"
                                                                }}>
                                                                {checkStatus(row.status).status}
                                                            </StyledTableCell>

                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        
                                        {data.length > 0 && <Box sx={{ display: "flex", justifyContent: "center" }}>
                                            <Pagination
                                                count={Math.ceil(payload.search !== "" ? tempData.length / pageSize : rows.length / pageSize)}
                                                page={page}
                                                onChange={handlePageChange}
                                                variant="outlined"
                                                shape="rounded"
                                                sx={{ marginTop: 2 }}
                                            />
                                        </Box>}
                                    </Box> :
                                    transaction.penaltyEmpty ?
                                    <Grid
                                        container
                                        columns={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        sx={{ marginTop: match ? 3 : 0 }}
                                    >
                                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                                            <Empty
                                                style={{
                                                    height: match ? "68%" : "50%",
                                                    width: match ? "68%" : "50%"
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                                            <Typography variant="h5"
                                                sx={{
                                                    fontWeight: "bold",
                                                    opacity: 0.7,
                                                }}
                                            >
                                                There are no transactions here!
                                            </Typography>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    fontSize: 15,
                                                    opacity: 0.7,
                                                }}
                                            >
                                                Select other transactions from the dashboard.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    :
                                    payload.search !== "" ?
                                            <Grid
                                                container
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: matches ? 3 : 0 }}
                                            >
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Searching
                                                        style={{
                                                            height: matches ? "68%" : "50%",
                                                            width: matches ? "68%" : "50%"
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                                    <Typography variant="h5"
                                                        sx={{
                                                            fontWeight: "bold",
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        No Found Transactions!
                                                    </Typography>
                                                    <Typography variant="subtitle1"
                                                        sx={{
                                                            fontSize: 15,
                                                            opacity: 0.7,
                                                        }}
                                                    >
                                                        Are you sure the transaction you're looking for is existing? Try looking for more.
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            :
                                            <Grid
                                                container
                                                direction="column"
                                                columns={12}
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={{ marginTop: "5%" }}
                                            >
                                                <Grid item xs>
                                                    <CircularProgress />
                                                </Grid>
                                            </Grid>
                                }
                                <Box sx={{ height: 500 }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>

            <Box sx={style.footerStyle}>
                {matches ?
                    <BottomMenu />
                    :
                    <Footer />}
            </Box>

        </Box>
    )
}
